export const theme = {
  colors: {
    primary: '#1a365d',
    secondary: '#2c5282',
    accent: '#2b6cb0',
    background: '#ffffff',
    surface: '#f7fafc',
    border: '#1034a6',
    text: {
      primary: '#2d3748',
      secondary: '#4a5568'
    }
  },
  transitions: {
    standard: 'all 0.2s ease-in-out'
  },
  card: {
    shadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  }
};
